import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const REGISTRYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RegistryType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.RegistryType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const REGISTRYTYPE_CONFIG = {
  entityName: 'RegistryType',
  localizationKey: 'Planning::Entity.RegistryType',
  fields: REGISTRYTYPE_FIELDS,
  permission: 'PlanningEnvironment.RegistryTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
